import { h, Component } from 'preact';
import s from 'components/bolt/expandableTextList/question.sss';
import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import HTML from 'components/core/html/html.js';

export default class Question extends Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	componentWillUpdate(nextProps) {
		if (nextProps.isOpen !== this.props.isOpen) {
			const $el = this.$answer.base;
			if (nextProps.isOpen) {
				$el.style.height = 'auto';
				let height = $el.clientHeight;
				$el.style.height = '';
				$el.clientWidth;
				$el.style.height = height + 'px';
				setTimeout(() => $el.style.height = '', 500);
			} else {
				$el.style.height = $el.clientHeight + 'px';
				$el.clientWidth;
				$el.style.height = '';
			}
		}
	}

	renderQuestionText() {
		return this.props.question;
	}

	renderQuestion() {
		return (
			<div class={joinClasses(s.title, 'large')} onClick={this.props.toggleActive}>
				{this.renderQuestionText()}
				<div class={s.icon} />
			</div>
		);
	}

	onClick(e) {
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
	}

	render(props) {
		const { answer, isOpen } = props;

		return (
			<div class={joinClasses(s.section, isOpen ? s.open : s.closed)}>
				{this.renderQuestion()}
				<HTML markdown class={s.content} onClickCapture={this.onClick} content={answer} ref={ref => this.$answer = ref} />
			</div>
		);
	}
}
